module.exports = __webpack_public_path__ + "static/media/textsms-material.b1b33510.svg";